<template>

	<AppLayout>
		<template #default>

			<AuthorizedWindow/>

		</template>
	</AppLayout>

</template>

<script setup>
import AppLayout from '@/layouts/AppLayout.vue'
import AuthorizedWindow from '@/components/windows/AuthorizedWindow.vue'
</script>
